import React from 'react';
import { BarChart } from '../../../components/barchart/barchart';
import { AppButtonIcon } from '../../../components/button-icon/app-button-icon';
import './pir-box-charts.scss';
import { PirBoxPieChart } from '../components/pir-box-pie-chart/pir-box-pie-chart';
import { YearlyPirIndicatorsBean } from 'azshared/build/main/lib/api/generated/objectway-zenith';
import { commonButtonMessages, usePirBoxPageLogic } from 'azshared';
import { useIntl } from 'react-intl';

export interface PirBoxChartsProps {
  dataSource: YearlyPirIndicatorsBean;
  onPrevious: () => void;
}

export const PirBoxCharts = (props: PirBoxChartsProps) => {
  const { dataSource, onPrevious } = props;
  const { formatMessage } = useIntl();
  const { productsSummary } = usePirBoxPageLogic();
  const summary = productsSummary.find((summary) => summary.pirCode === dataSource.pirCode);
  return (
    <div className='pirbox-charts'>
      {summary && (
        <>
          <BarChart dataSource={dataSource} summary={summary} />
          <div className='pirbox-pie'>
            <PirBoxPieChart summary={summary} />
          </div>
        </>
      )}
      <div>
        <AppButtonIcon className='pirbox-button-previous' icon='home-arrow' label={formatMessage(commonButtonMessages.backLink)} onClick={onPrevious} />
      </div>
    </div>
  );
};
